module.exports = __webpack_public_path__ + "img/gd-s.0301bdff.png";